<template>
  <termos-de-uso @voltar="$router.go(-1)"></termos-de-uso>
</template>
<script>
import TermosDeUso from '@/components/TermosDeUso/TermosDeUsoComponent'
export default {
  components: {
    TermosDeUso
  }
}
</script>
